import { Middleware } from 'redux'
import { REHYDRATE } from 'redux-persist/lib/constants'

import { LOGIN_SUCCESS, LOGOUT } from 'app/auth/state/types'
import { getUserContext } from 'utils/posthog'
import posthog from 'posthog-js'

const posthogMiddleware: Middleware = store => next => action => {
  if (action.type === LOGIN_SUCCESS) {
    const user = getUserContext(action)
    posthog.identify(user.id, {
      username: user.username,
      company: user.company
    })
  }

  if (action.type === REHYDRATE) {
    const user = getUserContext(store)
    if (user.id) {
      posthog.identify(user.id, {
        username: user.username,
        company: user.company
      })
    }
  }

  if (action.type === LOGOUT) {
    posthog.reset()
  }

  return next(action)
}

export default posthogMiddleware
